import { useRequiredContext } from "@redotech/react-util/context";
import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import CursorClickFilledIcon from "@redotech/redo-icons/cursor-click-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const PostPurchaseItems = memo(function PostPurchaseItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getConversionSubRoute("post-purchase"),
      }}
      FilledIcon={CursorClickFilledIcon}
      friendlyName="Post-purchase upsell"
      id="post-purchase"
      UnfilledIcon={CursorClickIcon}
    />
  );
});
